import React from 'react';
import { captureExceptionWithRecording } from '@whitelabel/helpers/utils';
import { logErrorBoundaryToDatadog } from '@whitelabel/cp-shared/helpers/datadogErrorLogging';
import ErrorPage from '../components/ErrorPage';

interface IErrorBoundaryProps {
  children: React.ReactElement;
}

interface IErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: undefined,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Note: Don't call setState here - getDerivedStateFromError already handles state updates.
    // Calling setState in componentDidCatch can cause infinite re-render loops (React Error #185)
    // when errors occur during the commit phase.

    logErrorBoundaryToDatadog(error, errorInfo);

    captureExceptionWithRecording(error, { componentStack: errorInfo.componentStack });
  }

  render() {
    const { error, hasError } = this.state;
    const { children } = this.props;

    if (error || hasError) return <ErrorPage />;
    return children;
  }
}

export default ErrorBoundary;
